import { HttpContextToken } from '@angular/common/http';
import { IGNORE_ALL_STATUSES } from 'src/app/core/constants/ignore-all-statuses';

export const IGNORE_STATUSES: HttpContextToken<Array<number> | typeof IGNORE_ALL_STATUSES> = new HttpContextToken<
  Array<number> | typeof IGNORE_ALL_STATUSES
>(() => []);
